export default {
	InvoiceList: {
		HeaderList: {
			Attached: 'Tệp đính kèm',
			SellerAddress: 'Địa chỉ nhà cung cấp',
			TaxReduction: 'Tổng số tiền thuế được giảm trên hóa đơn bán hàng giảm thuế',
			ChangeStatusInvoiceDate: 'Ngày thay đổi trạng thái trên Cơ quan thuế',
			WarningPaymentDueDate: 'Ngày nhắc hạn thanh toán',
			CompanyTax: 'Mã số thuế công ty',
			BranchTax: 'Mã số thuế chi nhánh',
			SellerTaxCode: 'Mã số thuế người bán',
			BuyerTaxCode: 'Mã số thuế người mua'
		}
	},

	DeclarationList: {
		HeaderList: {
			TotalPreCustomsFee: 'Tổng phí trước hải quan',
			TotalPreCustomsFeeExchange: 'Tổng phí trước hải quan quy đổi',
			CompanyTax: 'Mã số thuế công ty',
			BranchTax: 'Mã số thuế chi nhánh',
			InvoiceNo: 'Số hóa đơn'
		}
	}
};
